import { TIPO_INMOVILIZADO } from "api/Types/TipoInmobilizado"
import { TFunction } from "i18next"

export const tipoInmovilizado = (t: TFunction) => ({
  [TIPO_INMOVILIZADO.MATERIAL]: t("nsAssets.material"),
  [TIPO_INMOVILIZADO.INTANGIBLE]: t("nsAssets.intangible"),
})
